module.exports = __webpack_public_path__ + "img/spotify.45ff05a1.gif";